import { render, staticRenderFns } from "./Landbot.vue?vue&type=template&id=25392336"
import script from "./Landbot.vue?vue&type=script&lang=js"
export * from "./Landbot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports